import { useState, useEffect, forwardRef, useContext } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Slide,
  Box,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Stack,
  FormControl,
  InputLabel,
  FilledInput,
  InputAdornment,
  Menu,
  MenuItem,
  Avatar,
  ListItemAvatar,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { EventContext } from "../../../../../contexts/EventContext";
import request from "../../../../../utilities/requests";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const VoteConfiguration = ({ open, close, onSave }) => {


 

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={close}>
            <CloseIcon />
          </IconButton>

          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            Vote Configuration
          </Typography>
        </Toolbar>
      </AppBar>

  
    </Dialog>
  );
};

export default VoteConfiguration;
